<template>
  <div class="courseForm" :data="datalesson">
    <div v-if="datalesson.length==0" class="noResultInfo">
      <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
      <p class="font_24_reg">{{$t('tabBar.download')}}</p>
      <div class="flex_justify_center">
        <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
        <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />
      </div>
    </div>
    <div class="courseList" v-else>
        <div class="classList" v-for="(item, i) in datalesson" :key="i">
          <div class="flex_between titleBorder">
            <div class="titleName flex_center">
              <img :src="item.subject_img"/>
              <h3 class="font_24_bold">{{item.subject_title}} - {{item.start_lessons}}/{{item.total_lessons}}</h3>
            </div>
          </div>
          <div class="classTimeInfo">
            <div class="flex_between titleName">
              <p class="font_24_reg">{{item.start_date}}</p>
              <button class="font_16">{{item.level_title}}</button>
            </div>
              <p class="font_18_reg">{{item.start_time}} ({{item.duration}} mins)</p>
              <div class="flex_center topenterClassic"><p class="classTopic font_14 color_blue">{{$t('main.topic')}}</p><p class="font_18_reg">{{item.lesson_topic}}</p></div>
              <div class="flex_center topic"><p class="classTopic font_14 color_blue">{{$t('main.attendee')}} </p><img :src="item.student_avatar" /><p class="font_18_reg">{{item.nickname}}</p></div>
              <div class="flex_between">
                <div class="actBtn flex_justify_center">
                  <button class="leaveBtn" @click="viewFee(item.comments_id)" v-if="item.comments_status">{{$t('main.viewFeedback')}}</button>
                  <button class="enterClass" @click="leaveFee(item)" v-else>{{$t('main.leaveFeeback')}}</button>
                </div>
              </div>

          </div>
        </div>
    </div>
    <div v-if="isShowLeave" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate v-model="LeaveScore"
                :allow-half="true"
                void-color="#FF9F43"
                ></el-rate>
                <!-- <p v-for="(item, i) in scoreArray" :key="i" @hover="changeScore($event)">
                  <img class='star'
                  :src="LeaveScore > i ? (LeaveScore - i == 0.5  ?  callStarUrl : fullStarUrl)  : nullStarUrl" />
                </p> -->
              </div>
              <p>{{$t('main.comment')}}</p>
              <textarea :placeholder="$t('main.commentHere')" v-model="addComment"></textarea>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>{{$t('main.send')}}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 查看评论 -->
    <div v-if="isShowView" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseview">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate
                  v-model="viewData.rating"
                  disabled
                disabled-void-icon-class="none_icon">
                </el-rate>
                <!-- <p v-for="(item, i) in scoreArray" :key="i">
                  <img class='star'
                  :src="viewData.rating > i ? viewData.rating - i == 0.5  ?  callStarUrl : fullStarUrl  : nullStarUrl" />
                </p> -->
              </div>
              <p>{{$t('main.comment')}}</p>
              <p class="pl">{{viewData.comment}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>Send</span>
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
export default {
  props: {
    datalesson: Array,
    required: true
  },
  data () {
    return {
      lessondata: {},
      addComment: '',
      isShowLeave: false,
      isShowView: false,
      viewData: {},
      LeaveScore: 0, // 评分星星级别
      clickNum: 1,
      scoreArray: [1, 2, 3, 4, 5], // 分为1-5个评分层次
      fullStarUrl: require('../../assets/ant-design_star-filled.svg'), // 满星图片
      nullStarUrl: require('../../assets/ant-design_star-outlined.svg'), // 空星图片
      callStarUrl: require('../../assets/bx_bxs-star-half.svg') // 半星图片
    }
  },
  // watch:{
  //   //监控列表总数据量的变化
  //   datacourse(newVal,oldVal){
  //       //当总数据量变化时，重新计算分页的数量（需要显示多少页）
  //       this.data =newVal;
  //   }
  // },
  created () {

  },
  methods: {
    leaveFee (item) {
      this.lessondata = item
      this.isShowLeave = !this.isShowLeave
      this.LeaveScore = 0
    },
    viewFee (comments_id) {
      this.$http.get('/api/getComment?comment_id=' + comments_id).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.isShowView = !this.isShowView
          this.viewData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    chooseview () {
      this.isShowView = !this.isShowView
    },
    chooseImg () {
      this.isShowLeave = !this.isShowLeave
    },
    submitSick () {
      if (this.addComment == '' || this.LeaveScore == 0) {
        this.$message({
          message: 'Please give feedback',
          type: 'warning'
        })
        return false
      }
      this.$http.post('/api/setComment', {
        lesson_sn: this.lessondata.lesson_sn,
        student_sn: this.lessondata.student_sn,
        comment: this.addComment,
        rating: this.LeaveScore
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.isShowLeave = !this.isShowLeave
          this.$notify({
            message: this.$t('main.sendSuccess')
          })
          this.getLesson()
          // this.datalesson.map((item) => {
          //   if (item.lesson_sn == this.lessondata.lesson_sn && item.student_sn == this.lessondata.student_sn && res.data.status) {
          //     item.comments_status = true
          //   }
          // })
          // this.$forceUpdate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    getLesson () {
      let searchChild = getStore(keys.searchFilter)
      this.$http.get('/api/getCompletedLessonPC?student_sn=' + searchChild + '&time_diff=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.datalesson = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>

<style lang="less" scoped>
.courseForm{
  margin-top:25px;
  .noResultInfo{
    margin-top:80px;
    text-align: center;
    p{
      margin-bottom:32px;
    }
  }
  .courseList{
    margin:0 15px;
    >p.font_24_bold{
      margin:15px 0;
    }
    .classList{
      margin: 12px 0;
      background: #f8f8f8;
      border-radius: 5px;
      padding:15px 20px;
      .titleBorder{
        padding:10px;
        border-bottom: 1px solid rgba(165, 165, 165, 0.5);
      }
      .titleName{
        margin:10px 0;
        >img{
          width:21px;
          height:24px;
          margin-right:10px;
        }
        >span{
          width:6px;
          height:6px;
          border-radius: 2px;
          background: #a5a5a5;
          margin:0 20px;
        }
        >button{
          height: 36px;
          line-height: 36px;
          padding:0 10px;
          border:none;
          border-radius: 30px;
          background: #ffb800;
          color:#000;
        }
      }
      .classTimeInfo{
        margin-left:15px;
        margin-top:10px;
        .topic{
          margin-top:12px;
          .classTopic{
            margin-right:16px;
          }
          img{
            width:30px;
            height:30px;
            margin-right:8px;
          }
        }
        .studentList{
          background: #ffffff;
          border-radius: 8px;
          margin:10px 0 32px 0;
          padding:7px 0;
          >div{
            flex:1;
            padding:7px 16px;
            >.color_grey{
              margin-bottom:10px;
            }
            >.stuArr{
              line-height: 24px;
              p{
                width:100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              }
            }
          }
          .regularList{
            border-right:1px solid #F8F8F8;
          }
        }
        .actBtn{
          width: 100%;
          button{
            width:200px;
            height:50px;
            margin-right:10px;
          }
          img{
            box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20);
            border-radius: 50%;
            cursor: pointer;
          }
        }
        /deep/ .el-dropdown{
          .rightHead{
            background: none;
            border:none;
            color:#fff;
            font-size: 32px;
            padding:0;
            span{
              img{
                width:32px;
                height:32px;
              }
            }

          }
        }
      }
    }
  }
  .el-message-box__header{
    padding: 25px 84px 0;
    .el-message-box__title{
      margin-bottom:10px;
    }
    .el-message-box__headerbtn{
      top:25px;
    }
  }
  .el-message-box__content{
    color:#353643;
    padding-bottom:50px;
    .el-message-box__message{
      .pl{
        padding-left:50px;
        font-weight: normal;
      }
      >p{
        margin-bottom: 10px;
        font-weight: bold;
      }
      .starList{
        text-align: left;
        display: flex;
        margin-left:100px;
        /deep/ .el-rate{
          height:50px;
          .el-rate__icon{
              font-size: 35px;
              color: #FF9F43!important;
          }
          .el-rate__icon.hover{
            transform: scale(1);
          }
          .el-icon-star-on:before {
            content:url("../../assets/ant-design_star-filled.svg")
          }
          .none_icon:before,.el-icon-star-off:before{
            content:url("../../assets/ant-design_star-outlined.svg")
          }
        }
      }
      >textarea{
        width:530px;
        outline: none;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/views/lesson.vue